import React, { useRef } from "react";
import { useTrans } from "system/translations/hooks";
import FormBuilder from "services/formBuilder/FormBuilder";
import { useCreateMerchantWhiteList } from "modules/merchantWhiteList/apiHooks";
import { createEditValidation } from "modules/merchantWhiteList/validation";
import { useCreateEditConfig } from "modules/merchantWhiteList/constantHooks";
import { css } from "@emotion/react";
import { createStyles } from "types/emotion-styles";
import themeOptions from "system/theme";
import ActionButtons from "components/atoms/ActionButtons";
import { useDrawer } from "services/drawer/hooks";
import Divider from "components/atoms/Divider";
import DrawerInfo from "./DrawerInfo";

const styles = createStyles({
  wrapper: {
    display: "grid",
    height: "100%",
    gridTemplateRows: "1fr 72px",
  },
  container: {
    padding: themeOptions.spacing.lg,
  },
  buttonsWrapper: {
    padding: themeOptions.spacing.md,
    borderTop: `1px solid ${themeOptions.colors.gray300}`,
    display: "grid",
    justifyContent: "flex-end",
  },
});

const Create: React.FC<{ merchantId: number }> = ({ merchantId }) => {
  const { _t } = useTrans();
  const formikRef: any = useRef(null);
  const { hideDrawer } = useDrawer();
  const { mutate: onCreate, isLoading } =
    useCreateMerchantWhiteList(merchantId);
  const formConfig = useCreateEditConfig();
  const onSubmit = async () => {
    await formikRef?.current?.formik?.handleSubmit();
    if (formikRef?.current?.formik?.isValid) {
      const values = formikRef?.current?.formik?.values;
      await onCreate(values);
      hideDrawer();
    }
  };

  return (
    <div css={css(styles.wrapper)}>
      <div css={styles.container}>
        <FormBuilder
          formItemsConfig={formConfig}
          ref={formikRef}
          formProps={{
            validateOnMount: true,
            submitBtnLabel: _t("create"),
            onSubmit: onSubmit,
            initialValues: {},
            validationSchema: createEditValidation(_t, {
              isEdit: false,
            }),
          }}
        />
        <Divider/>
        <DrawerInfo />
      </div>
      <div css={styles.buttonsWrapper}>
        <ActionButtons
          onOkKind={"secondary"}
          onOk={onSubmit}
          onCancel={hideDrawer}
          isLoading={isLoading}
          onOkText={_t("add_ip_address")}
        />
      </div>
    </div>
  );
};

export default Create;
